// extracted by mini-css-extract-plugin
module.exports = {"iconContainer":"x8","iconEffect":"x9","ripple":"x-","a":"x_"};